import React from 'react'

import { Template, Breadcrumb } from '@components'

function ControleHoras() {
	const pages = [{ name: 'Controle de Horas', href: '#', current: true }]

	const date = new Date()
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')

	return (
		<Template>
			<Breadcrumb pages={pages} />

			<iframe
				src={`https://metabase.betalent.tech/public/dashboard/8bb0111f-79c5-4286-9835-200bf56a7ac6?ano=${year}&m%25C3%25AAs=${month}`}
				className='w-full h-[800px] border-none outline-none shadow-none'
				title='Controle de horas do Metabase'
			/>
		</Template>
	)
}

export default ControleHoras
